module.exports = __webpack_public_path__ + "static/excession-d61210ab220db51e087e9e9ec1a9508b.jpg";